module.exports = __webpack_public_path__ + "static/media/play-btn.ac31110e.svg";